import React from 'react';
import getOptions from '../../../../utils/getOptions';
import { Space } from 'antd';
import CalculoCantidadDias from '../../../../utils/CalculoCantidadDias';
import dayjs from 'dayjs';
// import MenuAcciones from '../Xinerlink/MenuAcciones';

export default function TurnosTrabajadoresColumns(
  items,
  openedRecord,
  setOpenedRecord
) {
  items.forEach((index) => {
    const fechaContrato = new Date(index.fechaInicio);
    const fechaActual = new Date();

    if (fechaContrato <= fechaActual) {
      if (index.asistencia === 'Llegó') {
        index.asistencia = 'Llegó';
      } else if (index.asistencia === 'No llegó') {
        index.asistencia = 'No llegó';
      } else if (index.asistencia === '') {
        index.asistencia = 'No se registró llegada en dotación diaria';
      } else {
        index.asistencia = 'No se registró llegada en dotación diaria';
      }
    } else {
      index.asistencia = 'Pendiente';
    }

    if (index.tipoContrato === 'ContratoObraFaena') {
      index.tipoContrato = 'Obra o Faena';
    } else if (index.tipoContrato === 'ContratoPlazoFijo') {
      index.tipoContrato = 'Plazo Fijo';
    }
  });
  const ordenados = items.sort(
    (a, b) => parseInt(a.idOferta) - parseInt(b.idOferta)
  );

  return [
    {
      fixed: 'left',
      title: 'Nro Oferta',
      width: 100,
      dataIndex: 'idOferta',
      key: 'idOferta',
      filterSearch: true,
      filters: getOptions(ordenados, 'idOferta'),
      onFilter: (v, record) => record.idOferta.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      fixed: 'left',
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      filterSearch: true,
      filters: getOptions(ordenados, 'nombre'),
      onFilter: (v, record) => record.nombre.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'RUT',
      dataIndex: 'dni',
      key: 'dni',
      filterSearch: true,
      filters: getOptions(ordenados, 'dni'),
      onFilter: (v, record) => record.dni.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Correo',
      dataIndex: 'correo',
      key: 'correo',
      filterSearch: true,
      filters: getOptions(ordenados, 'correo'),
      onFilter: (v, record) => record.correo.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Empresa Cliente',
      dataIndex: 'nombreEmpresa',
      key: 'nombreEmpresa',
      filterSearch: true,
      filters: getOptions(ordenados, 'nombreEmpresa'),
      onFilter: (v, record) => record.nombreEmpresa.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Razón Social Contratante',
      dataIndex: 'nombreEmpresaEmpleadora',
      key: 'nombreEmpresaEmpleadora',
      filterSearch: true,
      filters: getOptions(ordenados, 'nombreEmpresaEmpleadora'),
      onFilter: (v, record) => record.nombreEmpresaEmpleadora.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Rubro',
      dataIndex: 'rubro',
      key: 'rubro',
      filterSearch: true,
      filters: getOptions(ordenados, 'rubro'),
      onFilter: (v, record) => record.correo.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Fecha Inicio',
      dataIndex: 'fechaInicio',
      align: 'center',
      key: 'fechaInicio',
      filterSearch: true,
      filters: getOptions(ordenados, 'fechaInicio'),
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(text || '2023-01-01', record.estadoContrato) ? (
            <div style={{ color: 'red' }}>
              {dayjs(text).format('DD/MM/YYYY')}
            </div>
          ) : (
            <div>{dayjs(text).format('DD/MM/YYYY')}</div>
          )}
        </Space>
      ),
    },
    // {
    //   title: 'Tipo de Contrato',
    //   dataIndex: 'tipoContrato',
    //   key: 'tipoContrato',
    //   filterSearch: true,
    //   filters: getOptions(ordenados, 'tipoContrato'),
    //   onFilter: (v, record) => record.tipoContrato.indexOf(v) === 0,
    //   render: (text, record) => (
    //     <Space>
    //       {CalculoCantidadDias(
    //         record.fechaInicio || '2023-01-01',
    //         record.estadoContrato
    //       ) ? (
    //         <div style={{ color: 'red' }}>{text}</div>
    //       ) : (
    //         <div>{text}</div>
    //       )}
    //     </Space>
    //   ),
    // },
    {
      title: 'Asistencia',
      dataIndex: 'asistencia',
      key: 'asistencia',
      filterSearch: true,
      filters: getOptions(ordenados, 'asistencia'),
      onFilter: (v, record) => record.asistencia.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    // {
    //   title: 'Acciones',
    //   align: 'center',
    //   fixed: 'right',
    //   render: (text, record) => (
    //     <Space>
    //       <MenuAcciones
    //         record={record}
    //         openedRecord={openedRecord}
    //         setOpenedRecord={setOpenedRecord}
    //       />
    //     </Space>
    //   ),
    // },
  ];
}
